export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7579.ea63aea6.jpg";